import React from 'react';
import {CHECK, UNCHECK, useMuseumFilterDispatch, useMuseumFilterState} from "./museumFilterContext";
import {
    ListItemText,
    ListItemSecondaryAction,
    ListItemAvatar,
    ListItem,
    Checkbox,
    Avatar,
    useMediaQuery, useTheme
} from "@mui/material";
import {makeStyles} from "@mui/styles";

const useStyles = makeStyles(() => ({
    listItemText: {
        overflowX: "hidden"
    }
}))

export const MuseumListItem = ({museum}) => {
    const {
        checked,
        parents,
        museums,
        expanded
    } = useMuseumFilterState()
    const dispatch = useMuseumFilterDispatch()
    const theme = useTheme()
    const smUp = useMediaQuery(theme.breakpoints.up('sm'))
    const classes = useStyles()

    const onCheck = id => {
        if(checked.find(c => c === id)) {
            dispatch({
                type: UNCHECK,
                id: id
            })
        } else {
            dispatch({
                type: CHECK,
                id: id
            })
        }
    }

    const secondaryText = () => {
        const parent = parents.find(p => p.children.includes(parseInt(museum.id)))
        return parent ? museums.find(m => m.id ===parent.museumId).name : null
    }

    if(expanded || !smUp) {
        return (
            <ListItem>
                <ListItemAvatar>
                    <Avatar
                        alt={museum.name}
                        src={`https://${museum.profile}`}
                        sx={{
                            backgroundColor: museum.primaryColor,
                        }}
                    />
                </ListItemAvatar>
                <ListItemText
                    classes={{
                        root: classes.listItemText
                    }}
                    primary={museum.name}
                    secondary={secondaryText()}
                />
                <ListItemSecondaryAction>
                    <Checkbox
                        edge={"end"}
                        color={"primary"}
                        checked={Boolean(checked.find(c => c === museum.id))}
                        onChange={() => onCheck(museum.id)}
                    />
                </ListItemSecondaryAction>
            </ListItem>
        )
    } else {
        return (
            <ListItem>
                <ListItemAvatar>
                    <Avatar
                        alt={museum.name}
                        src={`https://${museum.profile}`}
                        sx={{
                            backgroundColor: museum.primaryColor,
                        }}
                    />
                </ListItemAvatar>
            </ListItem>
        )
    }
}